/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DocumentType {
    Miscellaneous = 0,
    CertificateOfInsurance = 1,
    CarrierPackets = 2,
    Rates = 3,
    FSC = 4,
    CustomerContract = 5,
    HazMat = 6,
    FAST = 7,
    CSA = 8,
    TWIC = 9,
    DOTInspection = 10,
    MaintenanceCheck = 11,
    COVIDVaccine1 = 13,
    COVIDVaccine2 = 14,
    COVIDVaccine3 = 15,
    DriverPhoto = 16,
    TSA = 17,
    CaliforniaCTC = 18,
    OregonPermit = 19,
    NewYorkPermit = 20,
    NewMexicoPermit = 21,
    KentuckyPermit = 22,
    CarrierBrokerageAgreement = 23,
    NOA = 24,
    Pet = 25,
    CarrierProfile = 26,
    BillingDocument = 27,
    HazMatTraining = 28,
    CustomerOnboard = 29,
    CtpatQuestionnaire = 30,
    CtpatCertification = 31,
    EscalationStandardOperatingProcedure = 32,
    StandardOperatingProcedure = 33,
    ApprovedPassenger = 34,
    DODApproved = 35,
    BcaAddendum = 36,
    CustomerWelcomePacket = 37,
    VehiclePhoto = 38,
    AccessorialCharges = 39,
    W9 = 40,
    SecurityThreatAssessment = 41,
    DriverLicense = 42,
}
